import styled from "styled-components";

export const ButtonLogo = styled.div`
  position: relative;
`;
